import React, { memo } from 'react';
import { ManagedPopup } from '@core/js/components/common/Popup';
import { useCombinedOnClose } from '@core/js/components/common/PopupManager';
import style from './NevisPasskeysSwissRenamePopup.scss';
import { Button } from '@core/js/components/common/Button';
import { I18n } from '@core/js/components/common/I18n';
import { useTranslations } from 'js/hooks/i18n';
import { ErrorMessage } from '@core/js/components/common/ErrorMessage';
import { Icon } from '../../../../common/Icon';
import { useEventHandlerForNevisPopup } from '../../hooks/useEventHandlerForNevisPopup';
import { INevisRenamePopup } from '@theme/js/components/main/NevisPasskeysSwiss/types';

export const NevisPasskeysSwissRenamePopup = memo(({
    id,
    title,
    onSuccess,
    resendHandler,
    onClose,
    declineBtnText,
    acceptBtnText,
    nameAuth,
    fidoAuthenticators,
    index,
    fetchPortlet,
    portletType,
    tkPrefix
} :INevisRenamePopup) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const t = useTranslations();

    const {
        isError,
        isAbove,
        isFocus,
        isDisabled,
        inputRef,
        onChange,
        onBlur,
        onFocus,
        clickOnInvalidIcon,
        onAcceptButton
    } = useEventHandlerForNevisPopup({
        fidoAuthenticators,
        index,
        fetchPortlet,
        portletType,
        closePopup,
        nameAuth
    });

    return (
        <ManagedPopup
            onClose={closePopup}
            title={title}
            onSuccess={onSuccess}
            className={style.popupContainer}
            resendHandler={resendHandler}
            isModal={true}>
            <div className={style.form}>
                <div className={style.inputContainerWrapper}>
                    <div className={`${style.inputContainer} ${isError && style.errorInputContainer}`}>
                        <I18n className={`${style.label} ${isAbove && style.labelAbove}`}
                              tKey={`${tkPrefix}passkeys.passkey.name`}/>
                        <div className={`${style.inputWrapper} ${isFocus && style.focus}`}>
                            <input
                                ref={inputRef}
                                type="text"
                                id={'nevis-rename'}
                                className={style.containerInput}
                                onBlur={onBlur}
                                onFocus={onFocus}
                                onKeyUp={onChange}
                            />
                        </div>
                        {isError && <ErrorMessage
                            error={t(`${tkPrefix}passkeys.passkey.name.error`)}
                            classNames={{ error: `${style.messageError} slideInDownErrors` }}
                        />}
                        {isError && <Icon
                            className={style.errorIcon}
                            onClick={clickOnInvalidIcon}
                        />}
                    </div>
                </div>
                <div className={style.popupButtons}>
                    <Button
                        type="submit"
                        view="primary"
                        color="negative"
                        onClick={closePopup}
                        className={style.button}>
                        {t(declineBtnText)}
                    </Button>
                    <Button
                        type="submit"
                        view="primary"
                        disabled={isDisabled}
                        className={style.button}
                        onClick={onAcceptButton}>
                        {t(acceptBtnText)}
                    </Button>
                </div>
            </div>
        </ManagedPopup>
    );
});
